<p-toast key="audio-files-editor" position="bottom-center"></p-toast>
<ng-container *transloco="let t; read: 'audio-files-editor'">
  <ng-template #audioFilesEditor>
    <form [formGroup]="form">
      <div>
        <span class="p-float-label w-full">
          <input class="w-full" id="audioDisplayName" pInputText type="text" [formControl]="displayName" />
          <label for="audioDisplayName">{{ t('displayNameLabel') }}</label>
        </span>
        <app-form-field-help [control]="displayName">
          <ng-container form-field-help-errors>
            <ng-container *ngIf="displayName.errors?.required">{{ t('displayNameRequired') }}</ng-container>
            <ng-container *ngIf="displayName.errors?.maxlength">{{ t('displayNameMaxLength') }}</ng-container>
          </ng-container>
        </app-form-field-help>
      </div>

      <p-tabView
        *ngIf="availableLanguages.length > 0"
        class="p-tab-view--full-height"
        [(activeIndex)]="activeTabIndex"
        (activeIndexChange)="onLanguageTabChange({ index: $event })"
      >
        <p-tabPanel *ngFor="let language of availableLanguages; let i = index" [header]="language.getDisplayName()">
        </p-tabPanel>
      </p-tabView>

      <ng-container>
        <div>
          <div *ngIf="loading || uploadInProgress" class="flex justify-content-center">
            <p-progressSpinner strokeWidth="2" [style]="{ width: '3rem', height: '3rem' }"></p-progressSpinner>
          </div>

          <app-audio-player
            *ngIf="vrcAudioMetadata && hasAudio && !loading && !uploadInProgress"
            class="full-width"
            [attr.data-language]="form.get('currentLanguage')?.value"
            [attr.key]="(form.get('currentLanguage')?.value || 'en') + '-' + (audioUrl || 'no-audio')"
            [playURL]="audioUrl"
          >
          </app-audio-player>
        </div>
        <div>
          <label class="block font-semibold" for="ssmlTextArea">{{ t('ssmlTextLabel') }}</label>
          <textarea
            class="full-width"
            id="ssmlTextArea"
            pInputTextarea
            rows="3"
            [formControl]="ssml"
            [placeholder]="t('ssmlTextInputPlaceholder')"
          ></textarea>

          <app-form-field-help [control]="ssml">
            <ng-container form-field-help-errors>
              <ng-container *ngIf="ssml.errors?.required && !hasSelectedFile">
                {{ t('ssmlTextRequiredError', { language: getCurrentLanguageDisplayName() }) }}
              </ng-container>
              <ng-container *ngIf="ssml.errors?.maxlength">
                {{ t('ssmlTextMaxLength') }}
              </ng-container>
            </ng-container>
            <ng-container form-field-help-hint>
              {{ t('ssmlTextHelp', { language: getCurrentLanguageDisplayName() }) }}
            </ng-container>
          </app-form-field-help>
        </div>
        <div class="audio-files-editor__audio-upload">
          <label class="block font-semibold">{{ t('fileUploadLabel') }}</label>
          <div *ngIf="selectedFile.value" class="p-2 mb-2 bg-primary-100 border-round">
            <small class="text-primary-500"> <strong>Selected file:</strong> {{ selectedFile.value.name }} </small>
          </div>
          <p-fileUpload
            #fu
            accept="audio/wav"
            chooseIcon="pi pi-upload"
            mode="basic"
            name="audioFile[]"
            styleClass="full-width-upload"
            [chooseLabel]="t('fileUploadPlaceholder')"
            [customUpload]="true"
            [disabled]="isFileUploadDisabled"
            [style]="{ width: '100%' }"
            (onSelect)="onFileSelect($event)"
          />

          <app-form-field-help [control]="selectedFile">
            <ng-container form-field-help-hint>
              {{ t('fileUploadHelp') }}
            </ng-container>
          </app-form-field-help>
        </div>
      </ng-container>
    </form>
  </ng-template>

  <app-settings
    [auditEntry]="auditEntry"
    [doUpload]="upload"
    [editorTemplate]="audioFilesEditor"
    [isValid]="isValid"
    [refreshData]="refreshData"
    [resetForm]="resetForm"
  >
  </app-settings>
</ng-container>
